import { Check } from "lucide-react";

const fmt = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : null);

export const TrackingTimeline = ({ stages, current, dates }) => {
  const idx = stages.findIndex((s) => s.code === current);
  return (
    <ol className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="tracking-timeline">
      {stages.map((s, i) => {
        const done = i <= idx;
        const active = i === idx;
        return (
          <li key={s.code} className={`relative rounded-md border p-3 ${active ? "border-terracotta bg-terracotta/5" : done ? "border-sage/60 bg-sage/10" : "border-border bg-white"}`} data-testid={`stage-${s.code}`} data-state={active ? "active" : done ? "done" : "pending"}>
            <div className="flex items-center gap-2">
              <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-semibold ${done ? "bg-charcoal text-white" : "border border-border text-warmgrey"}`}>
                {done ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              <p className={`text-xs font-medium ${done ? "text-charcoal" : "text-warmgrey"}`}>{s.label}</p>
            </div>
            <p className="mt-2 text-[11px] text-warmgrey">{fmt(dates?.[s.code]) || (done ? "date not recorded" : "pending")}</p>
          </li>
        );
      })}
    </ol>
  );
};
